import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account, CompanyAccount } from "model";

/**
* @class OneTimeACHPayment
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.oneTimeACHPayments[0];
* const contactInfo = new OneTimeACHPayment(record);
* @property {NUMBER} _id - The id of the OneTimeACHPayment.
*/
export default class OneTimeACHPayment extends BCMSRecord {
    _id
    _transactionType
    _secCode
    _schedule
    _effectiveDate
    _companyEntryDescription
    _companyAccount
    _offsetAccount
    _referenceNumber
    _creditAmount
    _debitAmount
    _batchName

    constructor (record){     
      super(record) 
    }
  }

  OneTimeACHPayment.define({
    "recordType": "oneTimeACHPayments",
    "recordIDProp": "id",
    "className" : "OneTimeACHPayment",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id value
       * @property set {NUMBER} - sets the id value
       * @memberof OneTimeACHPayment
       */
      BCMSRecordProperty.mapToNumber("id","_id"),

      /** 
       * @name transactionType
       * @instance
       * @property get {STRING} - gets the transactionType value
       * @property set {STRING} - sets the transactionType value
       * @memberof OneTimeACHPayment
       */
      BCMSRecordProperty.mapToString("transactionType", "_transactionType"),

       /** 
       * @name secCode
       * @instance
       * @property get {STRING} - gets the secCode value
       * @property set {STRING} - sets the secCode value
       * @memberof OneTimeACHPayment
       */
       BCMSRecordProperty.mapToString("secCode", "_secCode"),

        /** 
       * @name schedule
       * @instance
       * @property get {STRING} - gets the secCode value
       * @property set {STRING} - sets the secCode value
       * @memberof OneTimeACHPayment
       */
        BCMSRecordProperty.mapToString("schedule", "_schedule"),

        /** 
       * @name effectiveDate
       * @instance
       * @property get {STRING} - gets the secCode value
       * @property set {STRING} - sets the secCode value
       * @memberof OneTimeACHPayment
       */
        BCMSRecordProperty.mapToDate("effectiveDate", "_effectiveDate"),

        /** 
       * @name companyEntryDescription
       * @instance
       * @property get {STRING} - gets the companyEntryDescription value
       * @property set {STRING} - sets the companyEntryDescription value
       * @memberof OneTimeACHPayment
       */
        BCMSRecordProperty.mapToString("companyEntryDescription", "_companyEntryDescription"),

        /** 
       * @name companyAccount
       * @instance
       * @property get {STRING} - gets the companyAccount value
       * @property set {STRING} - sets the companyAccount value
       * @memberof OneTimeACHPayment
       */
        BCMSRecordProperty.mapToClass("companyAccount", "_companyAccount", () => CompanyAccount),

        /** 
       * @name companyAccount
       * @instance
       * @property get {STRING} - gets the offsetAccount value
       * @property set {STRING} - sets the offsetAccount value
       * @memberof OneTimeACHPayment
       */
        BCMSRecordProperty.mapToClass("offsetAccount", "_offsetAccount", () => Account),

        /** 
         * @name referenceNumber
         * @instance
         * @property get {STRING} - gets the referenceNumber
         * @property set {STRING} - sets the referenceNumber
         * @memberof OneTimeWireTransfer
         */
        BCMSRecordProperty.mapToString("referenceNumber","_referenceNumber"),

        /** 
         * @name creditAmount
         * @instance
         * @property get {STRING} - gets the creditAmount
         * @property set {STRING} - sets the creditAmount
         * @memberof OneTimeWireTransfer
         */
        BCMSRecordProperty.mapToString("creditAmount","_creditAmount"),

        /** 
         * @name debitAmount
         * @instance
         * @property get {STRING} - gets the debitAmount
         * @property set {STRING} - sets the debitAmount
         * @memberof OneTimeWireTransfer
         */
        BCMSRecordProperty.mapToString("debitAmount","_debitAmount"),

        /** 
         * @name batchName
         * @instance
         * @property get {STRING} - gets the batchName
         * @property set {STRING} - sets the batchName
         * @memberof OneTimeWireTransfer
         */
        BCMSRecordProperty.mapToString("batchName","_batchName"),
        
      /** 
       * @name numberOfPendingApprovals
       * @instance
       * @property get {NUMBER} - gets the numberOfPendingApprovals value
       * @property set {NUMBER} - sets the numberOfPendingApprovals value
       * @memberof OneTimeWireTransfer
       */
      BCMSRecordProperty.mapToString("numberOfPendingApprovals","_numberOfPendingApprovals"),

    ]  
})




